/**
 * 매장관리자 홈 Container
 * --
 */
import React from 'react';
// import MainHomePresenter from './MainHomePresenter';
import SalesDashboardContainer from 'routes/admin.routes/admin.dashboard/SalesDashboard';
import { useUserStack } from 'store';

const SalesDashboard = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <SalesDashboardContainer
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          shopType={'STORE'}
          summaryMode
        />
      )}
    </>
  );
};

export default SalesDashboard;
